export const getCookie = function (name) {
    var cookieValue = null
    if (document.cookie && document.cookie !== '') {
        var cookies = document.cookie.split(';')
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim()
            if (cookie.substring(0, name.length + 1) === name + '=') {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
                break
            }
        }
    }
    return cookieValue
}

export const setCookie = function (name, value, expires, path, domain, secure) {
    // options=options||{};
    if (value === null) {
        value = ''
        expires = -1
    }
    if (expires && (typeof expires === 'number' || expires.toUTCString)) {
        let date
        if (typeof expires === 'number') {
            date = new Date()
            date.setTime(date.getTime() + expires * 1000)
        } else {
            date = expires
        }
        expires = ';expires=' + date.toUTCString()
    }
    path = path ? ';path=' + path : ''
    domain = domain ? ';domain=' + domain : ''
    secure = secure ? ';secure' : ''
    document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('')
}



// WEBPACK FOOTER //
// ./src/basic/common/cookie.js